export default "/assets/site/images/hero.jpg?351f414a5bf683da77285f0cc165f437";